import { writable } from 'svelte/store';
export const createRootElementStore = () => {
    const rootElementStore = writable(null);
    return {
        set: rootElementStore.set,
        subscribe: rootElementStore.subscribe
    };
};
